<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('DisjointChannelTool', function() {
            return {
                group: 'Lines', category: 'Channels', icon: 'channel.svg',
                name: 'Disjoint Channel',
                type: 'DisjointChannel',
                hint: 'Non-parallel Channel',
                data: [],
                settings: {}
            }
        }, 'Disjoint Channel')
</script>
